<template>
    <div class="body-remind-wait">
        <div class="border-remind-wait">
            <div class="text-title">自定义提醒</div>
            <div class="scroll-box">
                <div class="text-item">提前</div>
                <div class="scroll-day">
                    <ScrollModule :items="days" :selected="day" @submitEvent="setSelect($event, 'day')"/>
                </div>
                <div class="text-item">天</div>
                <div class="scroll-hour">
                    <ScrollModule :items="hours" :selected="hour" @submitEvent="setSelect($event, 'hour')"/>
                </div>
                <div class="text-item">小时</div>
                <div class="scroll-minute">
                    <ScrollModule :items="minutes" :selected="minute" @submitEvent="setSelect($event, 'minute')"/>
                </div>
                <div class="text-item">分钟</div>
            </div>
            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "./ScrollModule";
import initData from "@/utils/initData";
export default {
    name: "RemindTimeDate",
    components: {
        ScrollModule
    },
    data(){
        return {
            days: [],
            hours: [],
            minutes: [],
            day: "0",
            hour: "0",
            minute: "0",
        }
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            const timeStamp = parseInt(this.day) * 1440 + parseInt(this.hour) * 60 + parseInt(this.minute);
            this.$emit("submitEvent", timeStamp);
            this.close();
        },
        setSelect: function(e, type){
            this[type] = e;
        },
    },
    created(){
        let days = [];
        for(let i=0; i<61; i++){
            days.push(i.toString());
        }
        this.days = days;

        initData.hours.forEach((item)=>{
            this.hours.push(parseInt(item).toString());
        })
        initData.minutes.forEach((item)=>{
            this.minutes.push(parseInt(item).toString());
        })
    },

}
</script>

<style scoped>
div.body-remind-wait{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-remind-wait{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.scroll-box{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    margin-top: 0.2rem;

    box-sizing: border-box;
    padding: 0.3rem 0.2rem;

    display: flex;
    align-items: center;
}
div.text-item{
    width: 0.5rem;
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}

div.scroll-day, div.scroll-hour, div.scroll-minute{
    flex: 1;
    height: 1.2rem;
    text-align: center;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>